import React from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  container: {
    marginBottom: 20,
  },
  phaseSection: {
    marginBottom: 15,
  },
  phaseHeader: {
    fontSize: 10,
    fontWeight: 'bold',
    marginBottom: 8,
    color: '#333333',
  },
  table: {
    width: '100%',
    marginBottom: 10,
  },
  tableHeader: {
    backgroundColor: '#f5f5f5',
    borderBottomWidth: 1,
    borderBottomColor: '#e0e0e0',
  },
  headerRow: {
    flexDirection: 'row',
  },
  headerCell: {
    fontSize: 7,
    fontWeight: 'bold',
    color: '#444444',
    padding: 4,
    textAlign: 'left',
    borderRightWidth: 1,
    borderRightColor: '#f0f0f0',
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#f0f0f0',
  },
  tableCell: {
    fontSize: 6,
    color: '#333333',
    padding: 3,
    borderRightWidth: 1,
    borderRightColor: '#f0f0f0',
  },
  abilityCell: {
    fontSize: 6,
    color: '#333333',
    fontWeight: 'bold',
    flex: 0.25,
  },
  competencyCell: {
    fontSize: 6,
    color: '#333333',
    flex: 0.35,
  },
  categoryCell: {
    fontSize: 6,
    textTransform: 'capitalize',
    flex: 0.15,
  },
  countCell: {
    fontSize: 6,
    textAlign: 'center',
    fontWeight: 'bold',
    flex: 0.12,
  },
  percentageCell: {
    fontSize: 6,
    textAlign: 'center',
    fontWeight: 'bold',
    flex: 0.13,
    borderRightWidth: 0,
  },
  emptyMessage: {
    fontSize: 7,
    color: '#888888',
    fontStyle: 'italic',
    textAlign: 'center',
    padding: 10,
  }
});

// Category colors matching the cinema map
const categoryColors = {
  skills: '#4CAF50',
  knowledge: '#2196F3',
  mindset: '#FF9800',
  instruments: '#9C27B0',
};

const TopCompetenciesTablePDF = ({ topCompetenciesData, totalParticipants }) => {
  const phases = ['Empathize', 'Define', 'Ideate', 'Prototype', 'Test', 'Communicate'];

  if (!topCompetenciesData || !totalParticipants) {
    return (
      <View style={styles.container}>
        <Text style={styles.emptyMessage}>
          No competency data available
        </Text>
      </View>
    );
  }

  return (
    <View style={styles.container}>
      {phases.map(phase => {
        const phaseData = topCompetenciesData[phase] || [];
        
        return (
          <View key={phase} style={styles.phaseSection}>
            <Text style={styles.phaseHeader}>{phase}</Text>
            
            {phaseData.length > 0 ? (
              <View style={styles.table}>
                <View style={styles.tableHeader}>
                  <View style={styles.headerRow}>
                    <Text style={{...styles.headerCell, ...styles.abilityCell}}>
                      Ability Name
                    </Text>
                    <Text style={{...styles.headerCell, ...styles.competencyCell}}>
                      Competency Name
                    </Text>
                    <Text style={{...styles.headerCell, ...styles.categoryCell}}>
                      Category
                    </Text>
                    <Text style={{...styles.headerCell, ...styles.countCell}}>
                      Times Selected
                    </Text>
                    <Text style={{...styles.headerCell, ...styles.percentageCell}}>
                      % of Participants
                    </Text>
                  </View>
                </View>
                
                {phaseData.map((item, index) => {
                  const categoryColor = categoryColors[item.category] || '#666666';
                  
                  return (
                    <View key={`${item.competencyId}-${index}`} style={styles.tableRow}>
                      <Text style={{...styles.tableCell, ...styles.abilityCell}}>
                        {item.abilityName}
                      </Text>
                      <Text style={{...styles.tableCell, ...styles.competencyCell}}>
                        {item.competencyName}
                      </Text>
                      <Text style={{
                        ...styles.tableCell, 
                        ...styles.categoryCell,
                        color: categoryColor
                      }}>
                        {item.category}
                      </Text>
                      <Text style={{...styles.tableCell, ...styles.countCell}}>
                        {item.count}
                      </Text>
                      <Text style={{...styles.tableCell, ...styles.percentageCell}}>
                        {item.percentage}%
                      </Text>
                    </View>
                  );
                })}
              </View>
            ) : (
              <Text style={styles.emptyMessage}>
                No competencies selected for this phase
              </Text>
            )}
          </View>
        );
      })}
    </View>
  );
};

export default TopCompetenciesTablePDF;
